import moment from 'moment';
import PropTypes from 'prop-types';

import { t } from '../lib/i18n';

export default class Reward {
    constructor(jsonData) {
        if (jsonData) {
            Object.assign(this, jsonData);
            this.averageDurationToCallback = this.averageDurationToCallback * 1.3;
        }
    }

    valueDescription() {
        const reward = this.reward;
        if (!reward) {
            return '';
        }
        if (reward.amount) {
            return `${reward.amount} ${reward.currency}`;
        } else if (reward.maxAmount) {
            return t('statusOverview.rewardWithLimit',
            { reward: `${reward.maxAmount} ${reward.currency}` });
        }
        return '';
    }

    statusColor() {
        return {
            PENDING: 'neutral',
            REJECTED: 'negative',
            CONFIRMED: 'positive',
            OBSOLETE: 'neutral',
        }[this.status];
    }

    statusName() {
        return t(`rewardStatus.${this.status}`);
    }

    userCanContactSupport() {
        const isOverdue = (Date.now() - this.eventTimestamp) > this.averageDurationToCallback;
        return this.status === 'PENDING' &&
            !this.userHasContactedSupport &&
            isOverdue;
    }

    durationFromNow() {
        return this.eventTimestamp && moment(this.eventTimestamp).fromNow();
    }

    averageDurationString() {
        return this.averageDurationToCallback &&
            moment.duration(this.averageDurationToCallback).humanize();
    }
}

Reward.propTypes = PropTypes.shape({
    campaignName: PropTypes.string.isRequired,
    reward: {
        amount: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
    },
    eventTimestamp: PropTypes.number.isRequired,
    averageDurationToCallback: PropTypes.number.isRequired,
});

export const stubStatusData = [
    {
        campaignName: 'Mittelalterquiz',
        reward: {
            amount: 5000,
            currency: 'Schwerter',
        },
        eventTimestamp: -20481726325257,
        averageDurationToCallback: 1000,
        userHasContactedSupport: false,
        status: 'PENDING',
        hashKey: '1MTgyMjU4NjIyMg',
    },
    {
        campaignName: 'Leuchtende Zukunft',
        reward: {
            maxAmount: 10,
            currency: 'Raumschifffahrtsantriebe (mit 3 \'f\')',
        },
        eventTimestamp: 22455561561651,
        averageDurationToCallback: 10032456531,
        userHasContactedSupport: false,
        status: 'PENDING',
    },
    {
        campaignName: 'Deichmann',
        reward: {
            maxAmount: 50000000,
            currency: 'Crocs',
        },
        eventTimestamp: 2801726325257,
        averageDurationToCallback: 20000,
        userHasContactedSupport: true,
        status: 'PENDING',
    },
    {
        campaignName: 'Schuh-App',
        reward: {
            amount: 45999,
            currency: 'Schwerter',
        },
        userHasContactedSupport: false,
        status: 'CONFIRMED',
    },
    {
        campaignName: 'Schuh-App',
        reward: {
            amount: 45999,
            currency: 'Schwerter',
        },
        reason: 'technical issues',
        status: 'REJECTED',
    },
    {
        campaignName: 'Schirm-App',
        reward: {
            amount: 45999,
            currency: 'Regentropfen',
        },
        reason: 'Sonniges Wetter bis zum ABWINKEN. Dieser Text ist übrigens relativ lang.',
        status: 'REJECTED',
    },
    {
        campaignName: 'Hut ab',
        reward: {
            amount: 29,
            currency: 'Hüte',
        },
        reason: 'UNKNOWN',
        status: 'REJECTED',
    },
    {
        campaignName: 'Pulli-app',
        reward: {
            amount: 45999,
            currency: 'Schwerter',
        },
        reason: 'Schwerter waren zu unscharf',
        status: 'REJECTED',
    },
];



// WEBPACK FOOTER //
// ./src/lib/reward.jsx